module.exports = __webpack_public_path__ + "img/block.4cc7cecb.svg";